__turbopack_context__.v({
  "inlineUnsafe": "InlineUnsafe-module__snEZPq__inlineUnsafe",
  "inlineUnsafeExtremely": "InlineUnsafe-module__snEZPq__inlineUnsafeExtremely",
  "inlineUnsafe__glossaryTerm": "InlineUnsafe-module__snEZPq__inlineUnsafe__glossaryTerm",
});
